import React, { useState } from 'react';

export default function Navbar({ page, setPage }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav>
      <div className="nav-inner">
        <div onClick={() => setPage('home')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}>
          <LogoSVG />
          <span style={{
            fontFamily: "'Bebas Neue', 'Arial Black', sans-serif",
            fontSize: 26, letterSpacing: '0.06em', lineHeight: 1,
            color: '#1A1A1A', fontWeight: 900, userSelect: 'none'
          }}>
            RENT<span style={{ color: '#C41230' }}>355</span>
          </span>
        </div>

        {/* Desktop links */}
        <div className="nav-links">
          <button className={`nav-link ${page === 'home' ? 'active' : ''}`} onClick={() => setPage('home')}>Home</button>
          <button className={`nav-link ${page === 'cars' ? 'active' : ''}`} onClick={() => setPage('cars')}>Fleet</button>
          <button
            className="btn-primary"
            style={{ padding: '9px 22px', fontSize: '13px', letterSpacing: '0.05em' }}
            onClick={() => setPage('admin')}
          >
            Admin
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          {menuOpen ? (
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          ) : (
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/></svg>
          )}
        </button>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <div className="nav-mobile-menu">
          <button className="nav-mobile-item" onClick={() => { setPage('home'); setMenuOpen(false); }}>Home</button>
          <button className="nav-mobile-item" onClick={() => { setPage('cars'); setMenuOpen(false); }}>Fleet</button>
          <button className="nav-mobile-item nav-mobile-admin" onClick={() => { setPage('admin'); setMenuOpen(false); }}>Admin</button>
        </div>
      )}
    </nav>
  );
}

function LogoSVG() {
  return (
    <svg width="40" height="40" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="47" stroke="#C41230" strokeWidth="4" fill="#0C0C0C"/>
      <rect x="17" y="21" width="66" height="18" rx="9" fill="#C41230"/>
      <rect x="17" y="44" width="66" height="15" rx="7.5" fill="#4A4A4A"/>
      <rect x="17" y="63" width="52" height="14" rx="7" fill="#3A3A3A"/>
    </svg>
  );
}
